import { Col } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import "./DemographicChart.css";

function DemographicChart({ data }) {
  let options = {
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
        },
      },
    },

    plugins: {
      legend: { display: false },
    },
  };

  return (
    <Col className="demographic-chart">
      <Col className="center">
        <h4 className="mb-4">{data.questionDescription}</h4>
      </Col>
      <Col>
        <Bar data={data} options={options} />
      </Col>
    </Col>
  );
}

export default DemographicChart;
